import React from 'react'
import styled from 'styled-components'

export const Avatar = ({
  className,
  text = '',
  url = '',
  alt = 'Avatar',
  size = 80,
  fontSize = 36
}) => {
  const avatarUrl = React.useMemo(() => {
    if (!url) return

    if (url.includes('googleusercontent.com')) {
      const googleUrl = url.split('=')

      if (googleUrl.length > 1) {
        return `${googleUrl[0]}=s${size}-c`
      } else {
        return `${googleUrl[0]}?size=${size}`
      }
    }

    return `${url}?size=${size}`
  }, [url, size])

  return (
    <Root className={className} size={size} fontSize={fontSize}>
      {!url && <span>{text?.charAt(0) ?? 'M'}</span>}
      {url && (
        <AvatarImage src={avatarUrl} referrerpolicy='no-referrer' alt={alt} />
      )}
    </Root>
  )
}

const Root = styled.div`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  font-size: ${({ fontSize }) => fontSize}px;
  text-transform: uppercase;
  user-select: none;
  background: #33bfe4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border-radius: 50%;
  font-weight: 500;
  position: relative;
  z-index: 1;
  position: relative;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
`

const AvatarImage = styled.img`
  height: 100%;
  width: 100%;
  border-radius: 50%;
  outline: transparent solid 2px !important;
  outline-offset: 2px;
`
